<div class="container-fluid">
  <div class="row   justify-content-start mb-2">
    <div class="col-12">
      <span class="iso-header ml-2">
        {{ "bikeshop.shop_setup.card_headers.shop_rides_widget" | translate }}
      </span>
    </div>
  </div>

  <div *ngIf="!loading">
    <form [formGroup]="configForm" (ngSubmit)="saveConfig(configForm.value)">
      <div>
        <div class="row">
          <div class="col-md-12">
            <div class="content">

              <div class="row margin-top-8" *ngIf="parentIdentifier && parentIdentifier.length > 0">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_ride_configuration.use_for_all_linked_stores" | translate }}:
                </div>
                <div class="col-md-1">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="useSettingForAllLinkedStores"></p-inputSwitch>
                  </div>
                </div>
              </div>


              <div class="row margin-top-8">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.shop_ride_configuration.theme" | translate
                  }}:
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.primary_colour" | translate
                  }}:
                </div>
                <div class="col-md-8">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.primaryColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.primaryColor }"
                      [colorPicker]="configForm.value.primaryColor"
                      (colorPickerChange)="updateColor($event, 'primaryColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.primaryColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.primary_text_colour" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.primaryTextColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.primaryTextColor }"
                      [colorPicker]="configForm.value.primaryTextColor"
                      (colorPickerChange)="updateColor($event, 'primaryTextColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.primaryTextColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.card_background" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.cardBackground}"
                      [ngStyle]="{ 'background-color' : configForm.value.cardBackground }"
                      [colorPicker]="configForm.value.cardBackground"
                      (colorPickerChange)="updateColor($event, 'cardBackground')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled">
                    </div>
                    <span *ngIf="!configForm.value.cardBackground"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate }}</small></span>
                  </div>
                </div>
              </div>
              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.default_background_colour" | translate
                  }}:
                </div>
                <div class="col-md-9">
                  <div style="display: flex;">
                    <div class="color-picker-custom" [ngClass]="{'not-set': !configForm.value.defaultBackgroundColor}"
                      [ngStyle]="{ 'background-color' : configForm.value.defaultBackgroundColor }"
                      [colorPicker]="configForm.value.defaultBackgroundColor"
                      (colorPickerChange)="updateColor($event, 'defaultBackgroundColor')" cpOutputFormat="hex"
                      cpAlphaChannel="disabled"></div>
                    <span *ngIf="!configForm.value.defaultBackgroundColor"><small>{{
                        'bikeshop.shop_ride_configuration.colour_not_set' | translate }}</small></span>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{
                  "bikeshop.shop_ride_configuration.card_border_radius" | translate
                  }}:
                </div>
                <div class="col-md-2 flex">
                  <div style="width: 100%">
                    <p-slider formControlName="cardBorderRadius" [min]="0" [max]="20"></p-slider>
                  </div>
                </div>
                <div class="col-md-1">
                  {{configForm.value.cardBorderRadius}}px
                </div>
              </div>


              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.shop_ride_configuration.custom_labels" | translate
                  }}:
                </div>
              </div>


              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_ride_configuration.header" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="headerLabel" />
                  </div>
                </div>
                <div class="col-md-5" style="padding-left:0px;">
                  <div class="p-inputgroup">
                    <small style="
                margin-top: auto;
                margin-bottom: auto;
              ">{{ "bikeshop.shop_ride_configuration.header_info" | translate }}</small>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_ride_configuration.join_ride_label" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="joinRideLabel" />
                  </div>
                </div>
                <div class="col-md-4" style="padding-left:0px;">
                  <div class="p-inputgroup">
                    <small style="
                margin-top: auto;
                margin-bottom: auto;
              ">{{ "bikeshop.shop_ride_configuration.join_ride_label_info" | translate }}</small>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{ "bikeshop.shop_ride_configuration.empty_list_label" | translate }}:
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <input type="text" pInputText formControlName="emptyListLabel" />
                  </div>
                </div>
                <div class="col-md-5" style="padding-left:0px;">
                  <div class="p-inputgroup">
                    <small style="
                margin-top: auto;
                margin-bottom: auto;
              ">{{ "bikeshop.shop_ride_configuration.empty_list_label_info" | translate }}</small>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{'bikeshop.shop_ride_configuration.custom_text' | translate}}:
                </div>
                <div class="col-md-4">
                  <div>
                    <quill-editor #additionalInfoEditor [modules]="modules" formControlName="customText"
                                  format="html"
                                  (onEditorCreated)="onQuillEditorCreated($event)">
                    </quill-editor>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-3 label">
                  {{'bikeshop.shop_ride_configuration.custom_text_position_above_button' | translate}}
                </div>
                <div class="col-md-4">
                  <div class="p-inputgroup">
                    <p-inputSwitch formControlName="customTextPositionAboveButton"></p-inputSwitch>
                    <small style="
                        margin-left: 8px;
                        margin-top: auto;
                        margin-bottom: auto;
                      ">
                    </small>
                  </div>
                </div>
              </div>


              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{
                  "bikeshop.shop_ride_configuration.custom_fonts" | translate
                  }}:
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-12 label-custom" [ngStyle]="{'font-family': configForm.value.defaultFontName}">
                  {{ "bikeshop.shop_ride_configuration.default_font" | translate }}:
                </div>
                <div class="col-md-12 margin-top-8">
                  <div class="font-options">
                    <div *ngFor="let font of fontOptions" (click)="updateFont(font)"
                      [ngClass]="{'selected':font.value === configForm.value.defaultFontName}"
                      [ngStyle]="{'font-family': font.value}">{{font.value}}</div>
                  </div>
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-12 label-custom">
                  {{ "bikeshop.shop_ride_configuration.secondary_font" | translate }}:
                </div>
                <div class="col-md-12 margin-top-8">
                  <div class="font-options">
                    <div *ngFor="let font of fontOptions" (click)="updateSecondaryFont(font)"
                      [ngClass]="{'selected':font.value === configForm.value.secondaryFontName}"
                      [ngStyle]="{'font-family': font.value}">{{font.value}}</div>
                  </div>
                </div>
              </div>


              <div class="row margin-top-16">
                <div class="col-md-4 label bold">
                  {{"bikeshop.shop_ride_configuration.custom_posters" | translate}}:
                </div>
              </div>

              <div class="row margin-top-8">
                <div class="col-md-12">
                  <div class="ride-type-options">
                    <div *ngFor="let rideType of rideTypeOptions">
                      <div [ngStyle]="{'background': configForm.value.primaryColor}">{{rideType.type}}</div>
                      <div [ngStyle]="{'background-image': 'url('+getPosterImage(rideType)+')'}"></div>
                      <input #fileUpload type="file" accept="image/*;capture=camera" style="display: none"
                        (change)="updateRideTypePoster($event, rideType.type)">
                      <div (click)="fileUpload.click()">{{'bikeshop.shop_ride_configuration.upload_image'|translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div class="row margin-top-16">
                  <div class="col-md-4 label bold">
                    {{"bikeshop.shop_ride_configuration.rentals" | translate}}:
                  </div>
                </div>

                <div class="row margin-top-8">
                  <div class="col-md-3 label">
                    {{ "bikeshop.shop_ride_configuration.link_rides_to_rentals" | translate }}
                  </div>
                  <div class="col-md-9">
                    <div class="p-inputgroup">
                      <p-inputSwitch formControlName="showRentalOptionFromWidget"></p-inputSwitch>
                      <small style="margin-left: 16px;">{{ "bikeshop.shop_ride_configuration.link_rides_to_rentals_desc"
                        | translate }}</small>
                    </div>
                  </div>
                </div>

                <div *ngIf="configForm.value.showRentalOptionFromWidget">
                  <div class="row margin-top-8">
                    <div class="col-md-3 label">
                      {{ "bikeshop.shop_ride_configuration.link_ride_types_to_rental_categories" | translate }}:
                    </div>
                    <div class="col-md-9 link-container">
                      <div class="p-inputgroup">
                        <p-dropdown [options]="rideTypeOptions" [(ngModel)]="selectedCategoryRideType"
                          [ngModelOptions]="{standalone: true}" optionLabel="type" optionValue="type"
                          [showClear]="false"
                          [placeholder]="'bikeshop.shop_ride_configuration.select_ride_type' | translate"></p-dropdown>
                      </div>
                      <div> 🔗 </div>
                      <div class="p-inputgroup">
                        <p-dropdown [options]="productCategories" [(ngModel)]="selectedProductCategory"
                          [ngModelOptions]="{standalone: true}" [showClear]="false"
                          [placeholder]="'bikeshop.shop_ride_configuration.select_rental_category' | translate"></p-dropdown>
                      </div>
                      <div>
                        <div class="mini-button" [ngClass]="{'linking': linkingRentalCategory}" *ngIf="selectedCategoryRideType && selectedProductCategory" (click)="linkRentalCategory()">
                          <daz-icon [name]="'plus'" [size]="'25px'" [color]="'white'"></daz-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row margin-top-8">
                    <div class="col-md-3"></div>
                    <div class="col-md-9">
                      <div class="linked-container">
                        <div *ngFor="let item of linkedCategories">
                          <div>{{item.rideType}}</div>
                          <div> 🔗 </div>
                          <div>{{getCategory(item.rentalCategoryID)}}</div>
                          <div class="remove-button" [ngClass]="{'unlinking': item.unlinking}" (click)="removeLinkedCategory(item)">
                            <div>
                              <daz-icon [name]="'trash'" [size]="'20px'" [color]="'white'"></daz-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="row margin-top-16">
                    <div class="col-md-3 label">
                      {{ "bikeshop.shop_ride_configuration.link_ride_types_to_rental_products" | translate }}:
                    </div>
                    <div class="col-md-9 link-container">
                      <div class="p-inputgroup">
                        <p-dropdown [options]="rideTypeOptions" [(ngModel)]="selectedProductRideType"
                          [ngModelOptions]="{standalone: true}" optionLabel="type" optionValue="type"
                          [showClear]="false"
                          [placeholder]="'bikeshop.shop_ride_configuration.select_ride_type' | translate"></p-dropdown>
                      </div>
                      <div> 🔗 </div>
                      <div class="p-inputgroup">
                        <p-dropdown [options]="productGroups" [(ngModel)]="selectedProductGroup"
                          [ngModelOptions]="{standalone: true}" [showClear]="false"
                          [placeholder]="'bikeshop.shop_ride_configuration.select_rental_product' | translate"></p-dropdown>
                      </div>
                      <div>
                        <div class="mini-button" [ngClass]="{'linking': linkingProduct}" *ngIf="selectedProductRideType && selectedProductGroup" (click)="linkRentalProduct()">
                          <daz-icon [name]="'plus'" [size]="'25px'" [color]="'white'"></daz-icon>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row margin-top-8">
                    <div class="col-md-3"></div>
                    <div class="col-md-9">
                      <div class="linked-container">
                        <div *ngFor="let item of linkedProducts">
                          <div>{{item.rideType}}</div>
                          <div> 🔗 </div>
                          <div>{{getProduct(item.rentalProductIdentifier)}}</div>
                          <div class="remove-button" [ngClass]="{'unlinking': item.unlinking}" (click)="removeLinkedProduct(item)">
                            <div>
                              <daz-icon [name]="'trash'" [size]="'20px'" [color]="'white'"></daz-icon>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <div class="row margin-top-16">
                <div class="col-md-9"></div>
                <div class="col-md-3">
                  <button type="submit" class="iso-round-button iso-light full-width"
                    [disabled]="!configForm.valid || saving">{{'bikeshop.shop_ride_configuration.save_configuration' |
                    translate}}</button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>

<div *ngIf="iFrameCreated && !saving" class="container-fluid" style="margin-top: 48px;">
  <div class="header-container">
    <div class="page-header">
      <span class="fa fa-id-badge"></span>{{ "bikeshop.shop_ride_configuration.widget_preview" | translate }}
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 margin-top-8 flex">
      <!-- <div class="copy-link">
        <input type="text" pInputText [(ngModel)]="dangerousURL" [disabled]="true" />
        <span class="fa fa-clipboard" pTooltip="{{'bikeshop.shop_ride_configuration.copy_link' | translate}}"
          (click)="copyLink()"></span>
      </div> -->
      <div>
        <button class="iso-round-button" (click)="copyLink()">{{'bikeshop.shop_ride_configuration.copy_link' |
          translate}}</button>
      </div>
      <div style="margin-left: 16px">
        <button class="iso-round-button" (click)="copyiFrame()">{{'bikeshop.shop_ride_configuration.copy_iframe' |
          translate}}</button>
      </div>
    </div>
  </div>
  <div class=" row margin-top-16">
    <div class="col-md-12">
      <div style="border: 1px solid #ccc;border-radius: 6px;overflow: hidden;"
        [ngStyle]="{'border-color': config.cardBackground || '#CCC'}">
        <iframe [src]="iFrameLink" width="100%" height="1500px" style="border: 0"></iframe>
      </div>

    </div>
  </div>
</div>

<p-toast position="top-center" styleClass="hubtiger-toast" key="link-copied"></p-toast>